// Loader.js
import React from 'react';
import './Loader.css'; // Create this file to style your loader

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
